<template lang="pug">
div
  p(v-if="lang == '繁体中文'")
    | 恭喜您, 訂單提交成功. 我們已經收到您的訂單,將盡快為您發寄出寶貝.溫馨提示：支持貨到付款+免郵費+7天鑒賞期！收到貨有任何疑問請聯繫我們在線客服! 也可隨時聯繫 : 
    a(:href="`mailto:${mail}`") {{mail}}
    | 。同時請附上您的姓名及聯繫方式及訂單編號在郵件當中，以便我們能快速的給您及時處理，祝您購物愉快！！
  p(v-if="lang == '英语'")
    | Congratulations ! Your order submitted successfully.We will delivery your good as soon as possible. Thank you for your support!Tips: Support cash on delivery+ Free shipping+ Seven days appreciation period. If you have any questions after receiving the good, please contact with our online service or send email to 
    a(:href="`mailto:${mail}`") {{mail}}
    | . Please remember to attach your name and order number in the message. We will reply you as soon as possible! Wish you a happy shopping!
  p(v-if="lang == '泰语'")
    | ขอแสดงความยินดีค่ะ    การสั่งซื้อสำเร็จเรียบร้อยแล้ว  เราจะส่งสินค้าหให้ท่าน้เร็วๆ นี้ ทิปส์  รองรับบริการเรียกเก็บเงินปลายทาง +รวมค่าขนส่ง+ในกรณีที่ไม่มีผลกระทบต่อการขายครั้งที่สอง คืนสินค้าได้ภายใน 7 วัน   หลังจากท่านได้รับสินค้าแล้ว  มีคำถามใดๆ โปรดติดต่อบริการลูกค้าออนไลน์ หรือติดต่อ email: 
    a(:href="`mailto:${mail}`") {{mail}}   
    | กรุณาใส่ชื่อและเบอร์มือถือของท่าน พร้อมใส่เลขที่สั่งซื้ออยู่ในอีเมลด้วย  ขอบคุณค่ะ
</template>

<script>
export default {
  props: ['lang'],
  data() {
    return {
      mail: 'dpcocoservice@outlook.com'
    }
  }
}
</script>